<template>
    <div>
        <template v-if="['Super Admin','admin', 'internal', 'pelaksana-suban','external'].includes(cookiesJenisAkun)">
            <div class="card mb-1">
                <div class="card-header px-2 text-uppercase">
                    <h4 class="font-weight-bold text-uppercase">
                        Filters & Pencarian
                    </h4>
                </div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="12" md="6" lg="6">
                            <b-form-group label="Tahun Pelaksanaan" label-for="tahunFilter">
                                <b-form-select id="tahunFilter" v-model="formFilter.tahun" :options="dsTahunPelaksanaan"
                                    disabled />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="6">
                            <b-form-group label="Versi" label-for="versiFilter">
                                <b-form-input id="versiFilter" v-model="formFilter.versi" disabled />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-6">
                            <b-form-group label="Wilayah" label-for="wilayahFilter">
                                <b-overlay :show="isLoadWilayah" variant="light" opacity="0.85" blur="2px" rounded="sm">
                                    <b-form-select id="wilayahFilter" v-model="formFilter.wilayah" :options="dsWilayah"
                                        @change="changeWilayah" />
                                </b-overlay>
                            </b-form-group>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6">
                            <b-form-group label="PD/UKPD/UPB" label-for="kolokFilter">
                                <b-overlay :show="isLoadKolok" variant="light" opacity="0.85" blur="2px" rounded="sm">
                                    <v-select id="kolokFilter" v-model="formFilter.kolok" label="text" :options="dsKolok" />
                                </b-overlay>
                            </b-form-group>
                        </div>
                    </div>
                    <b-row>
                        <b-col cols="12" class="d-flex justify-content-end">
                            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="md"
                                @click="submitFilter">
                                <feather-icon icon="SearchIcon" class="mr-1" />Cari
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </template>
        <div ref="formDaftarBmdRef" style="min-height: 50vh;">
            <List :parent-filter="filterValue" :fd="formDatas" @changeStateEvent="handleStateEvent" />
        </div>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BSpinner,
} from "bootstrap-vue";
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import { generateYears, startYear } from "@/libs/helper";
import vSelect from "vue-select";
import masterBRef from "@/composables/master/masterBRef";

import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { temp } from "@/@core/directives/animations";
import List from "./form/List"

export default {
    setup(props, context) {
        const g = context.root;
        const $route = g.$route;
        const cookiesJenisAkun = ref(g.$cookies.get("jenisAkun"));
        const year = g.$cookies.get("tahun") || moment().format('YYYY');
        const isLoadWilayah = ref(false);
        const isLoadKolok = ref(false);

        const stateEvent = ref('list');
        const formDatas = ref({});
        const formFilter = ref({
            tahun: year,
            versi: null,
            wilayah: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('wilayah') : '',
            kolok: null
        });
        const filterValue = ref({
            tahun: year,
            wilayah: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('wilayah') : 0,
            kolok: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('kolok') : null
        });
        /* Dataset */
        let tempListYear = [{
            text: '--Pilih Salah Satu--',
            value: '',
        }]
        if (g.$cookies.get('listTahun')) {
            const listTahun = JSON.parse(g.$cookies.get('listTahun'))
            tempListYear = [...tempListYear, ...listTahun.map(item => ({ ...item, value: item.tahun_pelaksanaan, text: item.tahun_pelaksanaan }))]
            filterValue.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value;
            formFilter.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value;

            const selectedTahun = listTahun.find(entry => entry.tahun_pelaksanaan === filterValue.value.tahun);
            formFilter.value.versi = selectedTahun.tahun_rekon + ' - ' + selectedTahun.kode_rekon;
        } else {
            tempListYear = [...tempListYear, ...generateYears(startYear, year)]
            filterValue.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value
            formFilter.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value
        }
        const dsTahunPelaksanaan = ref(tempListYear)
        const dsWilayah = ref([]);
        const getDsWilayah = () => {
            dsWilayah.value = [];
            isLoadWilayah.value = true;
            masterBRef.getWilayah(g).then(res => {
                if (res.success) {
                    res.rows.unshift({ text: '-- Semua --', value: '' })
                    dsWilayah.value = res.rows;
                }
                isLoadWilayah.value = false;

            }).catch(err => {
                isLoadWilayah.value = false;
                dsWilayah.value = [];
                console.log(err)
            });
        };
        getDsWilayah();

        /* --------- */
        const dsKolok = ref([]);
        const getDsKolok = (searchKolok = "") => {
            dsKolok.value = [];
            isLoadKolok.value = true;
            let params = {
                tahun: formFilter.value.tahun,
                wilayah: formFilter.value.wilayah,
                cari: searchKolok,
            };
            masterBRef.getKolokDs(g, params).then(res => {
                if (res.success) {
                    res.rows.unshift({ text: '-- Semua --', value: '' })
                    dsKolok.value = res.rows;
                }
                formFilter.value.kolok = (dsKolok.value) ? dsKolok.value?.[0] : null
                isLoadKolok.value = false;
            }).catch(err => {
                isLoadKolok.value = false;
                console.log(err)
            });

        };
        getDsKolok();

        /* Handler Function */
        const formDaftarBmdRef = ref(null);
        const handleStateEvent = (event) => {
            stateEvent.value = event;
            formDaftarBmdRef.value.scrollIntoView({ behavior: 'smooth' });
        }

        const submitFilter = () => {
            filterValue.value.tahun = formFilter.value.tahun;
            filterValue.value.wilayah = formFilter.value.wilayah;
            filterValue.value.kolok = (formFilter.value.kolok) ? formFilter.value.kolok.value : null;

            handleStateEvent('list')
        };

        const searchPdUpd = async search => {
            getDsKolok(search)
        }

        const changeWilayah = () => {
            formFilter.value.kolok = null
            getDsKolok()
        }

        /* On Mounted */
        /* ------------------------------- */

        /* Download Upload Dokumen SK Tim */
        const loadingCetak = ref(false);
        const cetakDokumenSkTim = () => {
            loadingCetak.value = true;
            setTimeout(() => {
                loadingCetak.value = false;
            }, 2000);
        }
        return {
            isLoadWilayah,
            isLoadKolok,
            formFilter,
            filterValue,
            dsTahunPelaksanaan,
            dsWilayah,
            dsKolok,
            submitFilter,
            searchPdUpd,
            changeWilayah,
            /////////////////

            formDaftarBmdRef,
            cookiesJenisAkun,

            stateEvent,
            formDatas,
            handleStateEvent,

            loadingCetak,
            cetakDokumenSkTim
        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BButton,
        BFormGroup,
        BFormSelect,
        BButton,
        BSpinner,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        List
    },
    data() {
        return {
            required
        };
    },

    methods: {

    },
    directives: {
        Ripple,
    },
    props: {
        page: String,
    },
};
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>